const OAUTH_POSTHOG_BOOTSTRAP_KEY = "chicky_posthog_oauth_bootstrap_v1";
const OAUTH_POSTHOG_BOOTSTRAP_MAX_AGE_MS = 30 * 60 * 1000;

type OAuthPostHogBootstrap = {
  sessionId: string;
  distinctId: string;
  createdAt: number;
};

export function stageOAuthPostHogBootstrap(
  storage: Storage,
  sessionId: string | null | undefined,
  distinctId: string | null | undefined,
  now = Date.now()
): boolean {
  try {
    storage.removeItem(OAUTH_POSTHOG_BOOTSTRAP_KEY);
    if (!sessionId || !distinctId) return false;

    const value: OAuthPostHogBootstrap = {
      sessionId,
      distinctId,
      createdAt: now,
    };
    storage.setItem(OAUTH_POSTHOG_BOOTSTRAP_KEY, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
}

export function consumeOAuthPostHogBootstrap(
  storage: Storage,
  searchParams: URLSearchParams,
  now = Date.now()
): Pick<OAuthPostHogBootstrap, "sessionId" | "distinctId"> | null {
  let stored: string | null = null;
  try {
    stored = storage.getItem(OAUTH_POSTHOG_BOOTSTRAP_KEY);
    storage.removeItem(OAUTH_POSTHOG_BOOTSTRAP_KEY);
  } catch {
    return null;
  }

  if (!stored) return null;

  try {
    const parsed = JSON.parse(stored) as Partial<OAuthPostHogBootstrap>;
    const sessionId = searchParams.get("ph_session_id");
    const distinctId = searchParams.get("ph_distinct_id");
    const age = now - (parsed.createdAt || 0);

    if (
      !sessionId ||
      !distinctId ||
      parsed.sessionId !== sessionId ||
      parsed.distinctId !== distinctId ||
      age < 0 ||
      age > OAUTH_POSTHOG_BOOTSTRAP_MAX_AGE_MS
    ) {
      return null;
    }

    return { sessionId, distinctId };
  } catch {
    return null;
  }
}

export function stripOAuthPostHogBootstrapParams(href: string): string | null {
  try {
    const url = new URL(href);
    const hadSessionId = url.searchParams.has("ph_session_id");
    const hadDistinctId = url.searchParams.has("ph_distinct_id");
    if (!hadSessionId && !hadDistinctId) return null;

    url.searchParams.delete("ph_session_id");
    url.searchParams.delete("ph_distinct_id");
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}

export function stripOAuthSignupMarker(href: string): string | null {
  try {
    const url = new URL(href);
    if (!url.searchParams.has("oauth_signup")) return null;

    url.searchParams.delete("oauth_signup");
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
}
